import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import API from 'utils/api/api'
import API_V1_URL from 'utils/api/urls_v1'
import DateTools from 'utils/dates/dateTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'


class HeaderIndicator extends Component {
	constructor(props) {
		super(props)
		const {
			intl: { formatNumber }
		} = this.props
		this.formatNumber = formatNumber

		this.state = {
			indicatorData: {},
			loading: true,
			error: false
		}
	}

	componentDidMount() {
		this.getIndicator()
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.setState({ loading: true, error: false }, () => this.getIndicator())
		}
	}

	getIndicator = ({ indicator } = { indicator: this.props.indicator }) => {
		if (this.props.selectedRegionId === null) return

		const dataAndMetaPromise = Promise.resolve(
			API.getQuery(API_V1_URL.getIndicatorData({ indicator, geo: [this.props.selectedRegionId], time: ["newest"], meta: true }))
		);

		Promise.all([dataAndMetaPromise])
			.then(response => {
				let data = response[0].data;
				let meta = response[0].meta;
				let indicatorData = meta;
				indicatorData.value = data[0].value
				indicatorData.lastUpdated = data[0].time
				this.setState({ indicatorData, loading: false })
			})
			.catch(reason => {
				console.error(reason);
				this.setState({ error: true, loading: false })
			})
	}

	renderIfAllOK() {
		let renderingComponent = null
		if (this.state.error) {
			renderingComponent = <Error />
		} else if (this.state.loading) {
			renderingComponent = <Loading />
		} else {
			let indicatorData = this.state.indicatorData
			let indicatorName = IndicatorTools.cleanIndicatorName( indicatorData.name );
			let indicatorUnit = IndicatorTools.cleanIndicatorUnit( indicatorData.unit );
			let indicatorNameMainPart = indicatorName.split('(')[0]
			let indicatorNameParenthesis = ''
			if (indicatorName.split('(')[1] === '' || indicatorName.split('(')[1] === undefined) {
				indicatorNameParenthesis = ''
			} else {
				indicatorNameParenthesis = '(' + indicatorName.split('(')[1]
			}
			const lastUpdated = DateTools.getYearFromDateString(indicatorData.lastUpdated)
			renderingComponent = (
				<div className="ork-region-overview__item" key={indicatorName}>
					<div className="ork-region-overview__item__img-block">
						<img src={this.props.imgPath} alt="" />
						<small>{lastUpdated}</small>
					</div>
					<div className="ork-region-overview__item__text-block">
						<span className="ork-region-overview__item__text-block__key">
							{indicatorNameMainPart} {indicatorNameParenthesis !== '' ? <br /> : ''} {indicatorNameParenthesis}
							{/* &nbsp; */}
						</span>
						<span className="ork-region-overview__item__text-block__value">
							{`${IndicatorTools.formatValue(indicatorData.value, indicatorData.unit)}`}{' '}
							<span className="ork-region-overview__item__text-block__unit">{`${indicatorUnit}`}</span>
						</span>
					</div>
				</div>
			)
		}
		return renderingComponent
	}

	render() {
		return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(HeaderIndicator)



// WEBPACK FOOTER //
// ./src/modules/Indicators/Header/HeaderIndicator/HeaderIndicator.jsx